import { z } from 'zod';

const charsOrMore = (value: string) => String(value ?? '').length >= 8;
const atLeastOneUppercase = (value: string) => /(?=.*?[A-Z])/g.test(String(value ?? ''));
const atLeastOneLowercase = (value: string) => /(?=.*?[a-z])/g.test(String(value ?? ''));
const atLeastOneNumeric = (value: string) => /(?=.*?[0-9])/g.test(String(value ?? ''));
const atLeastOneSpecial = (value: string) => /(.*[!@#$%^&*(),.?":{}|<>].*)/g.test(String(value ?? ''));

export const emailSchema = z
  .string({ error: 'Email is required' })
  .min(1, { message: 'Email is required' })
  .pipe(z.email({ message: 'Must be a valid email' }));

export const passwordSchema = z
  .string({ error: 'Password is required' })
  .min(1, { message: 'Password is required' })
  .refine(charsOrMore, { message: 'Password must contain at least 8 characters' })
  .refine(atLeastOneUppercase, { message: 'Password must contain at least one uppercase letter' })
  .refine(atLeastOneLowercase, { message: 'Password must contain at least one lowercase letter' })
  .refine(atLeastOneNumeric, { message: 'Password must contain at least one number' })
  .refine(atLeastOneSpecial, { message: 'Password must contain at least one special character' });

export const passwordWithConfirmationSchema = z
  .object({
    password: passwordSchema,
    confirmPassword: z.string().min(1, { message: 'Please confirm your password' }),
  })
  .check((ctx) => {
    if (ctx.value.password !== ctx.value.confirmPassword) {
      ctx.issues.push({
        code: 'custom',
        message: 'Passwords do not match',
        path: ['confirmPassword'],
        input: ctx.value,
      });
    }
  });
